module.exports = __webpack_public_path__ + "img/icon-payment-master.42956b56.png";